import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ImagenCliente, ImagenEmpleado } from "../../configuracion/apiUrls";
import { useContextUsuario } from '../../contexto/usuario/UsuarioContext';
import CerrarSesionButton from "../contenedores/CerrarSesion";
import NavItems from "./NavItems";
import RelojDigital from "./RelojDigital";

const SideNav = () => {
  const { usuario, invernaderoSeleccionado } = useContextUsuario();
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState([]);

  useEffect(() => {
    const currentPath = location.pathname;
    const items = usuario.tipo === "Empleado" ? navFiltrado : navItemClientes;

    const activeMenuIndex = items.findIndex(item =>
      item.urls?.some(subItem => subItem.url === currentPath)
    );

    if (activeMenuIndex !== -1 && !expandedItems.includes(activeMenuIndex)) {
      setExpandedItems(prev => {
        if (!prev.includes(activeMenuIndex)) {
          return [...prev, activeMenuIndex];
        }
        return prev;
      });
    }
  }, [location.pathname, usuario.tipo]);

  const handleMenuToggle = (index) => {
    setExpandedItems((prev) =>
      prev.includes(index)
        ? prev.filter((item) => item !== index)
        : [...prev, index]
    );
  };

  const isMenuExpanded = (index) => expandedItems.includes(index);
  const normalizarRuta = (ruta = "") => ruta.replace(/\/+$/, "");

  const navItemEmpleados = [
    {
      nombre: "Clientes",
      icono: "fas fa-user-tie",
      url: "/app/admin/clientes",
      urls: [
        { url: "/app/admin/clientes/nuevo", nombre: "Nuevo" },
        { url: "/app/admin/clientes/buscar", nombre: "Buscar" },
        { url: "/app/admin/clientes/editar", nombre: "Editar" },
      ]
    },
    {
      nombre: "Empleados",
      icono: "fas fa-users",
      url: "/app/admin/empleados",
      urls: [
        { url: "/app/admin/empleados/nuevo", nombre: "Nuevo" },
        { url: "/app/admin/empleados/buscar", nombre: "Buscar" },
        { url: "/app/admin/empleados/editar", nombre: "Editar" },
        { url: "/app/admin/empleados/cargos", nombre: "Cargos" },
        { url: "/app/admin/empleados/accesos", nombre: "Accesos" },
        { url: "/app/admin/empleados/resumen", nombre: "Resumen" },
        { url: "/app/admin/empleados/comparar", nombre: "Comparar" },
      ]
    },
    {
      nombre: "Actuadores",
      icono: "fas fa-cogs",
      url: "/app/admin/actuadores",
      urls: [
        { url: "/app/admin/actuadores/estadisticas", nombre: "Estadisticas" },
        { url: "/app/admin/actuadores/controles", nombre: "Controles" },
      ]
    },
    {
      nombre: "Invernaderos",
      icono: "fas fa-cogs",
      url: "/app/admin/invenaderos",
      urls: [
        { url: "/app/admin/invenaderos/estadisticas", nombre: "Estadisticas" },
      ]
    },
  ];

  const navItemClientes = [
    {
      nombre: "Citas",
      icono: "fas fa-calendar-alt",
      urls: [
        { url: "/app/clientes/citas/nuevo", nombre: "Nuevo" },
        { url: "/app/clientes/citas/editar", nombre: "Ver" },
      ]
    },
    {
      nombre: "Pedidos",
      icono: "fas fa-shopping-cart",
      urls: [
        { url: "/app/clientes/pedidos/nuevo", nombre: "Nuevo" },
        { url: "/app/clientes/pedidos/editar", nombre: "Ver" },
      ]
    }
  ];

  const accesosUsuario = Object.fromEntries(
    (usuario?.accesos || [])
      .filter(item => item?.ruta && item?.permisos)
      .map(item => {
        const ruta = normalizarRuta(item.ruta);
        const permisos = item.permisos.split(",").map(p => p.trim());
        return [ruta, permisos];
      })
  );

  const navFiltrado = navItemEmpleados
    .map(item => {
      const rutaItem = normalizarRuta(item.url || "");
      const permisos = accesosUsuario[rutaItem];
      if (!permisos) return null;

      const urlsFiltradas = item.urls?.filter(sub => permisos.includes(sub.nombre)) || [];
      return urlsFiltradas.length > 0 ? { ...item, urls: urlsFiltradas } : null;
    })
    .filter(Boolean);

  const imagen = usuario?.datoPersonales?.imagen
    ? usuario.tipo === "Cliente"
      ? ImagenCliente + usuario.datoPersonales.imagen
      : ImagenEmpleado + usuario.datoPersonales.imagen
    : usuario.tipo === "Cliente"
      ? ImagenCliente + "clientes.jpeg"
      : ImagenEmpleado + "empleados.jpeg";

  const nombreUsuario =
    usuario?.login != null
      ? `${usuario.datoPersonales.primerNombre} ${usuario.datoPersonales.primerApellido}`
      : "Usuario";

  const rutaPerfil =
    usuario?.tipo === "Empleado"
      ? "/app/admin/perfil"
      : usuario?.tipo === "Cliente"
        ? "/app/clientes/perfil"
        : "#";

  const primerGrupoAccesible = navFiltrado[0];
  const primeraRutaBase = primerGrupoAccesible?.url || "/app/admin/resumen";
  const primeraRutaBase2 = primerGrupoAccesible?.url || "/app/admin/comparar";

  if (usuario?.tipo === "Empleado" && !invernaderoSeleccionado) {
    return null;
  }

  const tienePermiso = (accesos, ruta, permiso) =>
  (accesos || []).some(
    a =>
      a.estado === "Activo" &&
      a.ruta === ruta &&
      a.permisos
        .split(",")
        .map(p => p.trim().toLowerCase())
        .includes(permiso.toLowerCase())
  );


  return (
    <aside className="main-sidebar main-sidebar-custom sidebar-dark-primary elevation-4" style={{ backgroundColor: "#2d9053ff" }}>
      <Link to={usuario.tipo === "Cliente" ? "/app/clientes/" : "/app/admin/empleados/"} className="brand-link d-flex align-items-center">
        <img
          src="/logoPrincipal.png"
          alt="Logo SIGAIN"
          className="brand-image img-circle elevation-3"
          style={{ opacity: ".8", width: "35px", height: "35px" }}
        />
        <span className="brand-text font-weight-light">SIGAIN</span>
      </Link>
      <div className="sidebar flex-grow-1" style={{ overflowY: 'auto' }}>
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <img
              className="img-circle elevation-2"
              src={imagen}
              alt="Imagen de perfil de usuario"
              crossOrigin="anonymous"
            />
          </div>
          <div className="info">
            <Link to={rutaPerfil} className="d-block text-white">
              {nombreUsuario}
            </Link>
          </div>
        </div>
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column nav-legacy" data-widget="treeview" role="menu" data-accordion="false">
            <li className="nav-header text-white">Menu Principal</li>
            {
              tienePermiso(usuario.accesos, "/app/admin/", "resumen") ? (
                <li className="nav-item">
                  <Link to="/app/admin/resumen" className="nav-link text-white">
                    <i className="nav-icon fas fa-chart-bar" />
                    <p>Sensores</p>
                  </Link>
                </li>
              ) : (<></>)
            }
            {
              tienePermiso(usuario.accesos, "/app/admin/", "Comparar") ? (
                <li className="nav-item">
              <Link to="/app/admin/comparar" className="nav-link text-white">
                <i className="nav-icon fas fa-project-diagram" />
                <p>Comparar Sensores</p>
              </Link>
            </li>
              ) : (<></>)
            }
            {
              tienePermiso(usuario.accesos, "/app/admin/", "Controles") ? (
                <li className="nav-item">
              <Link to="/app/admin/controles" className="nav-link text-white">
                <i className="nav-icon fas fas fa-cogs" />
                <p>Controles</p>
              </Link>
            </li>
              ) : (<></>)
            }
            {
              tienePermiso(usuario.accesos, "/app/admin/", "Estadisticas") ? (
                
              <li className="nav-item">
              <Link to="/app/admin/estadisticas" className="nav-link text-white">
                <i className="nav-icon fas fa-chart-area" />
                <p>Estadísticas Controles</p>
              </Link>
            </li>
           
              ) : (<></>)
            }
            {
              tienePermiso(usuario.accesos, "/app/admin/", "Seleccionar") ? (
                <li className="nav-item">
              <Link to="/app/admin/invernaderos" className="nav-link text-white">
                <i className="nav-icon fas fa-seedling" />
                <p>Invernaderos</p>
              </Link>
            </li>
              ) : (<></>)
            }
            
            {/*
              <NavItems
              items={usuario.tipo === "Empleado" ? navFiltrado : navItemClientes}
              handleMenuToggle={handleMenuToggle}
              isMenuExpanded={isMenuExpanded}
            />
            */}

            <li className="nav-item">
              <RelojDigital />
            </li>
          </ul>
        </nav>
      </div>
      <div className="sidebar-custom d-flex justify-content-between align-items-center p-3">
        <CerrarSesionButton />
      </div>
    </aside>
  );
};

export default SideNav;